export default __webpack_public_path__ + "37b0388156a0acd0d310e73a21647baa.png";